import React, { useState, useEffect } from "react";
import "../css/licenciados.css";

import Lic01 from "../img/licenciados/Licenciatura 8° 2024.jpeg";
import Lic02 from "../img/licenciados/Graduación Kinder 2024.jpg";
import Lic03 from "../img/licenciados/Licenciatura 8vo básico 2025.JPG";
import Lic04 from "../img/licenciados/Kinder 2025.jpg";

const licenciadosData = [
    { id: 4, year: 2025, title: "Graduación Kinder", generation: "Generación 2025", imageUrl: Lic04 },
    { id: 3, year: 2025, title: "Licenciatura 8° Básico", generation: "Generación 2025", imageUrl: Lic03 },
    { id: 2, year: 2024, title: "Graduación Kinder", generation: "Generación 2024", imageUrl: Lic02 },
    { id: 1, year: 2024, title: "Licenciatura 8° Básico", generation: "Generación 2024", imageUrl: Lic01 },
];

// Los años se obtienen automáticamente de los datos y se ordenan del más reciente al más antiguo.
const aniosDisponibles = [
    ...new Set(
        licenciadosData
            .map((item) => Number(item.year))
            .filter((year) => Number.isFinite(year))
    ),
].sort((a, b) => b - a);

const LicenciadosComponent = () => {
    const [anioSeleccionado, setAnioSeleccionado] = useState(
        aniosDisponibles[0] ?? new Date().getFullYear()
    );
    const [aniosDesplegados, setAniosDesplegados] = useState(false);
    const [imagenSeleccionada, setImagenSeleccionada] = useState(null);

    const abrirImagen = (imagen) => setImagenSeleccionada(imagen);
    const cerrarImagen = () => setImagenSeleccionada(null);

    useEffect(() => {
        if (!imagenSeleccionada) return;

        const manejarTeclado = (e) => {
            if (e.key === "Escape") cerrarImagen();
        };

        window.addEventListener("keydown", manejarTeclado);
        return () => window.removeEventListener("keydown", manejarTeclado);
    }, [imagenSeleccionada]);

    const licenciadosFiltrados = licenciadosData.filter(
        (item) => Number(item.year) === Number(anioSeleccionado)
    );

    return (
        <section id="licenciados-component" className="esc-lic-container">
            <h2 className="esc-lic-title">Licenciados &amp; Graduados</h2>

            <p className="esc-lic-subtitle">
                Un espacio dedicado a preservar la historia de cada generación que ha formado parte de la
                Escuela Nueva Zelandia. Aquí permanecen los recuerdos de las ceremonias de Graduación de
                Kinder y Licenciatura de 8° Básico para que estudiantes, familias y exalumnos puedan revivir
                estos importantes momentos a través del tiempo.
            </p>

            {/* SELECTOR DESPLEGABLE DE AÑOS */}
            <div className="esc-lic-years">
                <h3 className="esc-lic-years-title">
                    Recuerdos de nuestras generaciones
                </h3>
                <p className="esc-lic-years-description">
                    Selecciona un año para revivir sus ceremonias.
                </p>

                <div className="esc-lic-year-dropdown">
                    <button
                        type="button"
                        className={`esc-lic-year-selected ${aniosDesplegados ? "abierto" : ""}`}
                        onClick={() => setAniosDesplegados((anterior) => !anterior)}
                        aria-expanded={aniosDesplegados}
                        aria-label={`Año seleccionado ${anioSeleccionado}. ${aniosDesplegados ? "Ocultar años" : "Mostrar otros años"}`}
                    >
                        <span className="esc-lic-year-selected-icon">📅</span>
                        <span className="esc-lic-year-selected-text">Año {anioSeleccionado}</span>
                        <span className="esc-lic-year-arrow">▼</span>
                    </button>

                    {aniosDesplegados && (
                        <div className="esc-lic-year-options" role="group" aria-label="Años disponibles">
                            {aniosDisponibles.map((anio) => (
                                <button
                                    key={anio}
                                    type="button"
                                    className={`esc-lic-year-option ${anioSeleccionado === anio ? "activo" : ""}`}
                                    aria-pressed={anioSeleccionado === anio}
                                    onClick={() => {
                                        setAnioSeleccionado(anio);
                                        setAniosDesplegados(false);
                                    }}
                                >
                                    <span>{anio}</span>
                                    {anioSeleccionado === anio && (
                                        <span className="esc-lic-year-check">✓</span>
                                    )}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div className="esc-lic-periodo">
                <span className="esc-lic-periodo-linea" />
                <h3>Generación {anioSeleccionado}</h3>
                <span className="esc-lic-periodo-linea" />
            </div>

            {licenciadosFiltrados.length > 0 ? (
                <div className="esc-lic-grid">
                    {licenciadosFiltrados.map((item) => (
                        <article key={item.id} className="esc-lic-card">
                            <div className="esc-lic-header">{item.title}</div>

                            <div className="esc-lic-body">
                                <div
                                    className="esc-lic-image-wrapper"
                                    onClick={() => abrirImagen(item.imageUrl)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            abrirImagen(item.imageUrl);
                                        }
                                    }}
                                    role="button"
                                    tabIndex={0}
                                    aria-label={`Ampliar fotografía: ${item.title}, ${item.generation}`}
                                >
                                    <img
                                        src={item.imageUrl}
                                        alt={`${item.title} - ${item.generation}`}
                                        className="esc-lic-image"
                                        loading="lazy"
                                    />
                                    <div className="esc-lic-overlay">
                                        <span>🔍 Ampliar recuerdo</span>
                                    </div>
                                </div>
                            </div>

                            <div className="esc-lic-footer">
                                <div className="esc-lic-year">{item.generation}</div>
                            </div>
                        </article>
                    ))}
                </div>
            ) : (
                <div className="esc-lic-empty">
                    <div className="esc-lic-empty-icon">🎓</div>
                    <h3>Próximamente: Generación {anioSeleccionado}</h3>
                    <p>
                        Estamos preparando los recuerdos de las ceremonias de Licenciatura y Graduación
                        de esta generación.
                    </p>
                    <p>¡Muy pronto compartiremos estos momentos especiales!</p>
                </div>
            )}

            {imagenSeleccionada && (
                <div className="esc-lic-modal" onClick={cerrarImagen} role="presentation">
                    <button
                        type="button"
                        className="esc-lic-close"
                        onClick={cerrarImagen}
                        aria-label="Cerrar imagen ampliada"
                    >
                        ✕
                    </button>
                    <img
                        src={imagenSeleccionada}
                        alt="Fotografía ampliada de Licenciados y Graduados"
                        className="esc-lic-modal-image"
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
            )}
        </section>
    );
};

export default LicenciadosComponent;

